// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagFilterSvg from '@rsuite/icon-font/lib/application/TagFilter';
var TagFilter = createSvgIcon({
  as: TagFilterSvg,
  ariaLabel: 'tag filter',
  category: 'application',
  displayName: 'TagFilter'
});
export default TagFilter;